import { useFetchMembershipStatus } from '@/api/hooks/useFetchMembershipStatus'
import { useAuthStore } from '@/store'
import { Redirect, usePathname } from 'expo-router'

const ProtectedPage = ({ children }: { children: React.ReactNode }) => {
	const { isAuthenticated } = useAuthStore()
	const pathname = usePathname()
	const { hasActiveMembership, isFetchingStatus } = useFetchMembershipStatus()

	if (!isAuthenticated) {
		return (
			<Redirect
				href={{
					pathname: '/login',
					params: {
						redirectTo: pathname,
					},
				}}
			/>
		)
	}

	if (!isFetchingStatus && !hasActiveMembership) {
		return <Redirect href="/inactive-membership" />
	}

	return children
}

export default ProtectedPage
